var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{staticClass:"nostrokepath",attrs:{"x":"24","y":"24","width":"24","height":"24","rx":"6","transform":"rotate(-180 24 24.5)","fill":"#07CE6F"}}),_c('path',{staticClass:"nofillpath",attrs:{"d":"M15.75 14.375L12 10.625L8.25 14.375","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }